import React from "react";
import {Form, Input, Modal} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

export function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item label={'Name'} name={'name'} rules={[{
                    required: true
                }]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
